import React, { useState, useEffect } from "react"
import { HeaderBackTitle } from "../common/header"
import { CommonCategory } from "../common/category"
import _ from "lodash"
import { ImageModal } from "../modal"
import { EmptyData } from "../common/emptyData"
import { Footer } from "../common/footer"
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { _getPlacement } from "../../libraries/common"
import Redux from "@/action";
import { placementArea } from "../../config/site"
import { MyBody } from "../body/body"

export const VehicleGallery = (props) => {
    const { t, fetchedData, params } = props
    const { store, dispatch } = Redux();

    // category
    const [activeCategory, setActiveCategory] = useState(1)

    // imagel modal
    const [opened, setOpened] = useState(false)
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const galleryTap = [
        {id: 1, text: t("exterior")},
        {id: 2, text: t("interior")},
        {id: 3, text: t("other")}
    ]

    useEffect(()=>{
        const fetchData = async() => {
            if(store?.path?.dataPlacement == undefined){
                await _getPlacement(dispatch)
            }
        }
        fetchData()
    },[])

    return (
        <>
            {
                params?.vehicle?.[2] == 'gallery' &&
                <>
                    <AllMeta
                        title={t('vehicleBrandModelGalleryPage_meta_title', { brandModel: fetchedData?.name })}
                        description={t('vehicleBrandModelGalleryPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: !_.isEmpty(params?.[4]) ? fetchedData?.variant_name : fetchedData?.model_name  })}
                        keyword={t('vehicleBrandModelGalleryPage_meta_keyword', { brandModel: fetchedData?.name})}
                        image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
                        imageWidth={1275}
                        imageheight={666}
                    />
                    <Head><title>{t('vehicleBrandModelGalleryPage_title', {brandModel: fetchedData?.name})}</title></Head>
                </>
            }
            <MyBody
                t={t}
                isSubTab={true}
                headerComponent={
                    <HeaderBackTitle 
                        title={!_.isEmpty(params?.[4]) ? fetchedData?.variant_name : !_.isEmpty(fetchedData?.model_name) ? fetchedData?.model_name : t('car_gallery')} 
                        showSearch={false}
                        showMenu={false}
                        t={t}
                        subTab={
                            <CommonCategory 
                                data={galleryTap}
                                activeCategory={activeCategory}
                                setActiveCategory={setActiveCategory}
                                t={t}
                                isAllAllow={false}
                                isFull={true}
                                isSubTab={true}
                            />
                        }
                    />
                }
                modalComponent={
                    <ImageModal
                        setOpened={setOpened}
                        opened={opened}
                        data={fetchedData?.[activeCategory]}
                        currentIndex={currentIndex}
                        setCurrentIndex={setCurrentIndex}
                        thumbsSwiper={thumbsSwiper}
                        setThumbsSwiper={setThumbsSwiper}
                        t={t}
                        isFullLink={true}
                    />
                }
            >
                {
                    !_.isEmpty(fetchedData?.vehicle_list?.[activeCategory]) ?
                    <>
                        {
                            (() => {
                                // this is sum the total each variant total row, for image modal use
                                let totalImage = 0;
                                // this is push on key what + prev total row
                                let totalImageArray = {}
                                return _.reduce(fetchedData?.vehicle_list?.[activeCategory], (result, value, key)=>{
                                    // push total on that key 
                                    totalImageArray[key] = totalImage
                                    result.push(
                                        <React.Fragment key={`${activeCategory}-${key}`}>
                                            {
                                                _.isEmpty(params?.[4]) && 
                                                <p className="fontSize_20 fontWeight_bold containerPadding vehicleGallery_list_title">
                                                    {value?.variant_name}
                                                </p>
                                            }
                                            <div className="vehicleGallery_list containerPadding">
                                                <div onClick={()=>{setOpened(true);setCurrentIndex(totalImageArray[key])}} className={`vehicleGallery_list_item vehicleGallery_list_item_main cursorPointer`}>
                                                    <img src={process.env.NEXT_PUBLIC_FS_URL + value?.galler_list[0]} loading="lazy" />
                                                </div>
                                                {
                                                    _.reduce(value?.galler_list,(result2, value2, key2)=>{
                                                        if(key2 >= 1){
                                                            // each row + 1 
                                                            totalImage++
                                                            if(key2 == 3){
                                                                // each row + 1 
                                                                totalImage++
                                                            }
                                                            result2.push(
                                                                <div key={`${activeCategory}-${value?.variant_name}-${key2}`} 
                                                                    onClick={()=>{
                                                                        setOpened(true);
                                                                        // because 3, is placement ads
                                                                        setCurrentIndex(totalImageArray[key] + ((key2 >= 3 && !_.isEmpty(store?.path?.dataPlacement?.[placementArea?.gallerModal_3rdImage])) ? (key2 + 1) : key2))
                                                                    }} 
                                                                    className={`vehicleGallery_list_item cursorPointer`}
                                                                >
                                                                    <img key={`${activeCategory}-${value?.variant_name}-${key2}`} src={process.env.NEXT_PUBLIC_FS_URL + value2} loading="lazy" />
                                                                </div>
                                                            )
                                                        }
                                                        return result2
                                                    },[])
                                                }
                                            </div>
                                        </React.Fragment>
                                    )
                                    // each row + 1, because prev got 1 big image not inside the reduce result2
                                    totalImage++
                                    return result
                                },[])
                            })()
                        }
                    </>
                    :
                    <EmptyData t={t} />
                }
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         {
    //             params?.vehicle?.[2] == 'gallery' &&
    //             <>
    //                 <AllMeta
    //                     title={t('vehicleBrandModelGalleryPage_meta_title', { brandModel: fetchedData?.name })}
    //                     description={t('vehicleBrandModelGalleryPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: !_.isEmpty(params?.[4]) ? fetchedData?.variant_name : fetchedData?.model_name  })}
    //                     keyword={t('vehicleBrandModelGalleryPage_meta_keyword', { brandModel: fetchedData?.name})}
    //                     image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
    //                     imageWidth={1275}
    //                     imageheight={666}
    //                 />
    //                 <Head><title>{t('vehicleBrandModelGalleryPage_title', {brandModel: fetchedData?.name})}</title></Head>
    //             </>
    //         }
            
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'  style={{overflowX: 'hidden'}}>
    //                 <HeaderBackTitle 
    //                     title={!_.isEmpty(params?.[4]) ? fetchedData?.variant_name : !_.isEmpty(fetchedData?.model_name) ? fetchedData?.model_name : t('car_gallery')} 
    //                     showSearch={false}
    //                     showMenu={false}
    //                     t={t}
    //                 />
    //                 <div>
    //                     <CommonCategory 
    //                         data={galleryTap}
    //                         activeCategory={activeCategory}
    //                         setActiveCategory={setActiveCategory}
    //                         t={t}
    //                         isAllAllow={false}
    //                         isFull={true}
    //                     />
    //                 </div>
    //                 {
    //                     !_.isEmpty(fetchedData?.vehicle_list?.[activeCategory]) ?
    //                     <>
    //                         {
    //                             (() => {
    //                                 // this is sum the total each variant total row, for image modal use
    //                                 let totalImage = 0;
    //                                 // this is push on key what + prev total row
    //                                 let totalImageArray = {}
    //                                 return _.reduce(fetchedData?.vehicle_list?.[activeCategory], (result, value, key)=>{
    //                                     // push total on that key 
    //                                     totalImageArray[key] = totalImage
    //                                     result.push(
    //                                         <React.Fragment key={`${activeCategory}-${key}`}>
    //                                             {
    //                                                 _.isEmpty(params?.[4]) && 
    //                                                 <p className="fontSize_20 fontWeight_bold containerPadding vehicleGallery_list_title">
    //                                                     {value?.variant_name}
    //                                                 </p>
    //                                             }
    //                                             <div className="vehicleGallery_list containerPadding">
    //                                                 <div onClick={()=>{setOpened(true);setCurrentIndex(totalImageArray[key])}} className={`vehicleGallery_list_item vehicleGallery_list_item_main cursorPointer`}>
    //                                                     <img src={process.env.NEXT_PUBLIC_FS_URL + value?.galler_list[0]} loading="lazy" />
    //                                                 </div>
    //                                                 {
    //                                                     _.reduce(value?.galler_list,(result2, value2, key2)=>{
    //                                                         if(key2 >= 1){
    //                                                             // each row + 1 
    //                                                             totalImage++
    //                                                             if(key2 == 3){
    //                                                                 // each row + 1 
    //                                                                 totalImage++
    //                                                             }
    //                                                             result2.push(
    //                                                                 <div key={`${activeCategory}-${value?.variant_name}-${key2}`} 
    //                                                                     onClick={()=>{
    //                                                                         setOpened(true);
    //                                                                         // because 3, is placement ads
    //                                                                         setCurrentIndex(totalImageArray[key] + ((key2 >= 3 && !_.isEmpty(store?.path?.dataPlacement?.[placementArea?.gallerModal_3rdImage])) ? (key2 + 1) : key2))
    //                                                                     }} 
    //                                                                     className={`vehicleGallery_list_item cursorPointer`}
    //                                                                 >
    //                                                                     <img key={`${activeCategory}-${value?.variant_name}-${key2}`} src={process.env.NEXT_PUBLIC_FS_URL + value2} loading="lazy" />
    //                                                                 </div>
    //                                                             )
    //                                                         }
    //                                                         return result2
    //                                                     },[])
    //                                                 }
    //                                             </div>
    //                                         </React.Fragment>
    //                                     )
    //                                     // each row + 1, because prev got 1 big image not inside the reduce result2
    //                                     totalImage++
    //                                     return result
    //                                 },[])
    //                             })()
    //                         }
    //                     </>
    //                     :
    //                     <EmptyData t={t} />
    //                 }
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //         <ImageModal
    //             setOpened={setOpened}
    //             opened={opened}
    //             data={fetchedData?.[activeCategory]}
    //             currentIndex={currentIndex}
    //             setCurrentIndex={setCurrentIndex}
    //             thumbsSwiper={thumbsSwiper}
    //             setThumbsSwiper={setThumbsSwiper}
    //             t={t}
    //             isFullLink={true}
    //         />
    //     </>
    // )
}